import { Type } from 'class-transformer';
import { CompanyOwnerNameRawDto } from './company-owner-name-raw-dto';
import { IndividualOwnerNameRawDto } from './individual-owner-name-raw-dto';
import { OwnerMailingAddressRawDto } from './owner-mailing-address-raw-dto';
import { OwnerPropertyAddressResultDto } from './owner-property-address-result-dto';
import { OwnerRightesAndPrivilegeRawDto } from './owner-rights-and-privilege-raw-dto';
import { OwnershipResultDto } from './ownership-result-dto';

export class OwnerInfoResultDto {
  @Type(() => IndividualOwnerNameRawDto)
  individualOwnerName: IndividualOwnerNameRawDto;
  @Type(() => CompanyOwnerNameRawDto)
  companyOwnerName: CompanyOwnerNameRawDto;
  @Type(() => OwnerRightesAndPrivilegeRawDto)
  rightAndPrivilege: OwnerRightesAndPrivilegeRawDto;
  @Type(() => OwnershipResultDto)
  ownership: OwnershipResultDto;
  @Type(() => OwnerMailingAddressRawDto)
  mailingAddress: OwnerMailingAddressRawDto;
  @Type(() => OwnerPropertyAddressResultDto)
  propertyAddress: OwnerPropertyAddressResultDto;
  allowToggleMailingAddressIsValid: boolean;
}
